import { useState } from 'react';
import { Send, Clock, History, Smartphone, Image } from 'lucide-react';
import EnviarTab from './central/EnviarTab';
import ProgramarTab from './central/ProgramarTab';
import HistoricoTab from './central/HistoricoTab';
import DispositivosTab from './central/DispositivosTab';
import BannersTab from './central/BannersTab';

type TabId = 'enviar' | 'programar' | 'historico' | 'dispositivos' | 'banners';

interface TabDef {
  id: TabId;
  label: string;
  icon: React.ReactNode;
}

const TABS: TabDef[] = [
  { id: 'enviar', label: 'Enviar', icon: <Send size={16} /> },
  { id: 'programar', label: 'Programar', icon: <Clock size={16} /> },
  { id: 'historico', label: 'Histórico', icon: <History size={16} /> },
  { id: 'dispositivos', label: 'Dispositivos', icon: <Smartphone size={16} /> },
  { id: 'banners', label: 'Banners', icon: <Image size={16} /> },
];

/**
 * Central do Cliente — painel admin de notificações push.
 *
 * 4 tabs:
 *  - Enviar: broadcast manual (por userIds OU filtro cidade/bairro)
 *  - Programar: TODO (backend ainda não suporta scheduling)
 *  - Histórico: lista PushNotification com filtros
 *  - Dispositivos: lista PushDevice + desativar
 */
export default function Central() {
  const [active, setActive] = useState<TabId>('enviar');

  return (
    <div className="p-6 md:p-10 max-w-7xl mx-auto">
      <header className="mb-6 flex items-center gap-3">
        <div className="w-12 h-12 rounded-xl bg-primary-soft/40 text-primary flex items-center justify-center">
          <Smartphone size={24} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-fg">Central do Cliente</h1>
          <p className="text-sm text-fg-2">Notificações push para o app do cliente final</p>
        </div>
      </header>

      <div className="border-b border-line mb-6 flex gap-1 overflow-x-auto">
        {TABS.map((t) => {
          const isActive = active === t.id;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => setActive(t.id)}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition whitespace-nowrap ${
                isActive
                  ? 'border-primary text-primary'
                  : 'border-transparent text-fg-2 hover:text-fg'
              }`}
            >
              {t.icon}
              {t.label}
            </button>
          );
        })}
      </div>

      <div>
        {active === 'enviar' && <EnviarTab />}
        {active === 'programar' && <ProgramarTab />}
        {active === 'historico' && <HistoricoTab />}
        {active === 'dispositivos' && <DispositivosTab />}
        {active === 'banners' && <BannersTab />}
      </div>
    </div>
  );
}
